import request from '@/utils/request'
import { AxiosResult, AxiosPagination } from '@/typings/common'

//  获取列表数据
export function labelList(data: { appId: string }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/label/treeList', data)
}

export function saveLabel(data:any) {
  return request.post<AxiosResult>('/base/api/label/save', data)
}
export function updateLabel(data:any) {
  return request.post<AxiosResult>('/base/api/label/update', data)
}
export function deleteLabel(data:any) {
  return request.post<AxiosResult>('/base/api/label/delete', data)
}
